import React, {useState} from "react";
import Link from 'next/link';
import Text from "../Shared/Text";
import styles  from './styles.module.scss';
import Button from "../Button";

export default function EventPodcastSection({path, events, podcasts}) {

    const [active, setActive] = useState(0);

    const select = (index) => {
        if ( active == index ) {
            setActive(null);
            return;
        }
        setActive(index); 
    }

     const tabs = [
        { label: 'Event', value: 0 },
        { label: 'Podcast', value: 1 },
    ]

    return (
        <div className={styles.cont }>
            <div className={styles.subcont}>
                <Text path={path}/>
                <div className={styles.tabs}>
                    {
                        tabs.map((tab, index) => (
                            <div key={index} onClick={() => select(index)} className={`${styles.tab} ${active === index ? styles.active : ''}`}>{tab.label}</div>
                        ))
                    }
                </div>
                {
                    active === 0 &&
                    <div className={styles.content}>
                    {
                        events.map((event, index) => (
                            <EventPodcastCard key={index} item={event} />
                        ))
                    }
                    </div>
                }
                {
                    active === 1 &&
                    // podcasts.map((podcast, index) => (
                    //     <EventPodcastCard key={index} item={podcast} />
                    // ))
                    <iframe title="Let’s Get Inclusive" allowtransparency="true" className={styles.iframe} scrolling="no" data-name="pb-iframe-player" src="https://www.podbean.com/player-v2/?i=fw28c-6e5bae-pbblog-playlist&share=1&download=1&rtl=0&fonts=Arial&skin=1&font-color=&logo_link=episode_page&order=episodic&limit=10&filter=all&ss=a713390a017602015775e868a2cf26b0&btn-skin=7&size=315" loading="lazy" allowFullScreen></iframe>
                }
                <Button link={"#subscribe-now"} display="JOIN OUR DIGITAL COMMUNITY" variant="black"/>
            </div>
            
        </div>
    )
}

function EventPodcastCard({item}) {
    return <div className={styles.solutionCard}>
        <img src={item.image || "/images/placeholders/img-placeholder.jpg"} className={styles.image}></img>
        <div className={styles.content}>
            <div className={styles.contentCont}>
                <h5>{item.title}</h5>
                <Link href={item.link || '/'}>ACCESS WEBINAR <span>+</span></Link>
            </div>
            <div className={styles.hidden}>
                <h5>{item.title}</h5>
                <Link href={item.link || '/'}>ACCESS WEBINAR <span>+</span></Link>
            </div>
        </div>
    </div>
}